import { j as n } from "./jsx-runtime-p91LotPX.mjs";
import { GrowFlex as h } from "./BaseComponents/Flex/Flex.js";
import { ResetIconRegular as B, ClearRegular as R, SearchIconRegular as k } from "./Icons/Icons.js";
import "./GrowAvatar-DJSlhesM.mjs";
import { GrowButton as p } from "./BaseComponents/Button/AntButton.js";
import "./BaseComponents/CheckBox/style.js";
import { GrowTypography as D } from "./BaseComponents/Typography/AntTypography.js";
import "./BaseComponents/utils/datetime-formatter.js";
import "./core.esm-D9FG3ApV.mjs";
import "./SortableItem-C--6XTJo.mjs";
import "./lodash-lyheMOjd.mjs";
import * as g from "react";
import "./BaseComponents/Dnd/SortableContainer.js";
import "./AntDrawer-ChgesM8B.mjs";
import "./style-BCs5tvAM.mjs";
import "./BaseComponents/StatusTag/style.js";
import "./main-C3-4ZYQP.mjs";
import "./BaseComponents/Table/ColumnCustom/ColumnSort/ColumnSortList.js";
import "./table-XsUAem3c.mjs";
import "./style-pk1ekFUy.mjs";
import "./BaseComponents/Table/BulkAction/style.js";
import "./BaseComponents/Table/Pagination/style.js";
import "./BaseComponents/Table/style.js";
import "./BaseComponents/Tree/style.js";
import "./BaseComponents/UI/FormArea/FormFooter.js";
import "./BaseComponents/css.js";
import { I as P } from "./index-Dp_V09On.mjs";
import { g as T, m as G, b as W, u as c, a as H, q as _, s as A } from "./index-CjjiqU7h.mjs";
const V = (e) => {
  const {
    componentCls: t,
    sizePaddingEdgeHorizontal: a,
    colorSplit: r,
    lineWidth: i,
    textPaddingInline: d,
    orientationMargin: l,
    verticalMarginInline: s
  } = e;
  return {
    [t]: Object.assign(Object.assign({}, W(e)), {
      borderBlockStart: `${c(i)} solid ${r}`,
      // vertical
      "&-vertical": {
        position: "relative",
        top: "-0.06em",
        display: "inline-block",
        height: "0.9em",
        marginInline: s,
        marginBlock: 0,
        verticalAlign: "middle",
        borderTop: 0,
        borderInlineStart: `${c(i)} solid ${r}`
      },
      "&-horizontal": {
        display: "flex",
        clear: "both",
        width: "100%",
        minWidth: "100%",
        // Fix https://github.com/ant-design/ant-design/issues/10914
        margin: `${c(e.dividerHorizontalGutterMargin)} 0`
      },
      [`&-horizontal${t}-with-text`]: {
        display: "flex",
        alignItems: "center",
        margin: `${c(e.dividerHorizontalWithTextGutterMargin)} 0`,
        color: e.colorTextHeading,
        fontWeight: 500,
        fontSize: e.fontSizeLG,
        whiteSpace: "nowrap",
        textAlign: "center",
        borderBlockStart: `0 ${r}`,
        "&::before, &::after": {
          position: "relative",
          width: "50%",
          borderBlockStart: `${c(i)} solid transparent`,
          // Chrome not accept `inherit` in `border-top`
          borderBlockStartColor: "inherit",
          borderBlockEnd: 0,
          transform: "translateY(50%)",
          content: "''"
        }
      },
      [`&-horizontal${t}-with-text-left`]: {
        "&::before": {
          width: `calc(${l} * 100%)`
        },
        "&::after": {
          width: `calc(100% - ${l} * 100%)`
        }
      },
      [`&-horizontal${t}-with-text-right`]: {
        "&::before": {
          width: `calc(100% - ${l} * 100%)`
        },
        "&::after": {
          width: `calc(${l} * 100%)`
        }
      },
      [`${t}-inner-text`]: {
        display: "inline-block",
        paddingBlock: 0,
        paddingInline: d
      },
      "&-dashed": {
        background: "none",
        borderColor: r,
        borderStyle: "dashed",
        borderWidth: `${c(i)} 0 0`
      },
      [`&-horizontal${t}-with-text${t}-dashed`]: {
        "&::before, &::after": {
          borderStyle: "dashed none none"
        }
      },
      [`&-vertical${t}-dashed`]: {
        borderInlineStartWidth: i,
        borderInlineEnd: 0,
        borderBlockStart: 0,
        borderBlockEnd: 0
      },
      [`&-plain${t}-with-text`]: {
        color: e.colorText,
        fontWeight: "normal",
        fontSize: e.fontSize
      },
      [`&-horizontal${t}-with-text-left${t}-no-default-orientation-margin-left`]: {
        "&::before": {
          width: 0
        },
        "&::after": {
          width: "100%"
        },
        [`${t}-inner-text`]: {
          paddingInlineStart: a
        }
      },
      [`&-horizontal${t}-with-text-right${t}-no-default-orientation-margin-right`]: {
        "&::before": {
          width: "100%"
        },
        "&::after": {
          width: 0
        },
        [`${t}-inner-text`]: {
          paddingInlineEnd: a
        }
      }
    })
  };
}, L = (e) => ({
  textPaddingInline: "1em",
  orientationMargin: 0.05,
  verticalMarginInline: e.marginXS
}), q = T("Divider", (e) => {
  const t = G(e, {
    dividerHorizontalWithTextGutterMargin: e.margin,
    dividerHorizontalGutterMargin: e.marginLG,
    sizePaddingEdgeHorizontal: 0
  });
  return [V(t)];
}, L, {
  unitless: {
    orientationMargin: !0
  }
});
var F = function(e, t) {
  var a = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (a[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (a[r[i]] = e[r[i]]);
  return a;
};
const y = (e) => {
  const {
    getPrefixCls: t,
    direction: a,
    divider: r
  } = g.useContext(H), {
    prefixCls: i,
    type: d = "horizontal",
    orientation: l = "center",
    orientationMargin: s,
    className: b,
    rootClassName: $,
    children: m,
    dashed: w,
    plain: S,
    style: C
  } = e, j = F(e, ["prefixCls", "type", "orientation", "orientationMargin", "className", "rootClassName", "children", "dashed", "plain", "style"]), o = t("divider", i), [z, O, N] = q(o), f = !!m, u = l === "left" && s != null, v = l === "right" && s != null, I = _(o, r == null ? void 0 : r.className, O, N, `${o}-${d}`, {
    [`${o}-with-text`]: f,
    [`${o}-with-text-${l}`]: f,
    [`${o}-dashed`]: !!w,
    [`${o}-plain`]: !!S,
    [`${o}-rtl`]: a === "rtl",
    [`${o}-no-default-orientation-margin-left`]: u,
    [`${o}-no-default-orientation-margin-right`]: v
  }, b, $), x = g.useMemo(() => typeof s == "number" ? s : /^\d+$/.test(s) ? Number(s) : s, [s]), E = Object.assign(Object.assign({}, u && {
    marginLeft: x
  }), v && {
    marginRight: x
  });
  if (process.env.NODE_ENV !== "production") {
    const M = A("Divider");
    process.env.NODE_ENV !== "production" && M(!m || d !== "vertical", "usage", "`children` not working in `vertical` mode.");
  }
  return z(/* @__PURE__ */ g.createElement("div", Object.assign({
    className: I,
    style: Object.assign(Object.assign({}, r == null ? void 0 : r.style), C)
  }, j, {
    // biome-ignore lint/a11y/useAriaPropsForRole: divider do not need aria-value
    role: "separator"
  }), m && d !== "vertical" && /* @__PURE__ */ g.createElement("span", {
    className: `${o}-inner-text`,
    style: E
  }, m)));
};
process.env.NODE_ENV !== "production" && (y.displayName = "Divider");
const U = y;
function $e(e) {
  const t = /* @__PURE__ */ n.jsx(p, { actionButton2: !0, className: "grow-comp", icon: /* @__PURE__ */ n.jsx(B, { color: e.isOrderChange ? "var(--gray-5)" : "var(--primary-7)" }), iconButton: "without_bg", size: "small", style: {
    color: e.isOrderChange ? "var(--gray-5)" : "var(--primary-7)",
    paddingRight: 0
  }, type: "text", onClick: e.onReset, disabled: e.isOrderChange, children: "Reset" }), a = /* @__PURE__ */ n.jsx(p, { type: "text", size: "small", style: {
    color: "var(--primary-7)"
  }, onClick: e.onSelectAll, children: "All" }), r = /* @__PURE__ */ n.jsx(p, { type: "text", size: "small", style: {
    color: "var(--primary-7)"
  }, onClick: e.onSelectNone, children: "None" }), i = /* @__PURE__ */ n.jsx(D.Text, { children: "Select:" }), d = /* @__PURE__ */ n.jsx(k, {});
  return /* @__PURE__ */ n.jsxs("div", { style: {
    width: "100%"
  }, children: [
    /* @__PURE__ */ n.jsxs(h, { justify: "center", style: {
      width: "100%",
      padding: "var(--space-8) var(--space-8) var(--space-4) var(--space-8)"
    }, space: "8", vertical: !0, children: [
      /* @__PURE__ */ n.jsx(P, { placeholder: "Search Column", allowClear: {
        clearIcon: /* @__PURE__ */ n.jsx(R, {})
      }, prefix: d, onChange: (l) => {
        e.onSearch(l.target.value.trim());
      } }),
      /* @__PURE__ */ n.jsxs(h, { justify: "space-between", align: "center", style: {
        width: "100%"
      }, children: [
        /* @__PURE__ */ n.jsxs(h, { space: "4", align: "center", children: [
          i,
          a,
          r
        ] }),
        t
      ] })
    ] }),
    /* @__PURE__ */ n.jsx(U, { style: {
      borderColor: "var(--gray-5)",
      margin: "var(--space-4) var(--space-8)"
    } })
  ] });
}
export {
  $e as C,
  U as D
};
//# sourceMappingURL=ColumnSearch-DyjTqam1.mjs.map
